import { useTranslation } from '@packlink/translation-provider';
import {
    Button,
    ButtonSize,
    ButtonVariant,
    Dialog,
    DialogActions,
    DialogContent,
    DialogHeader,
    Typography,
} from '@shipengine/giger';

export type ToggleDialogProps = {
    activeToggle: boolean;
    isOpen: boolean;
    templateKey?: string;
    originFromEdition?: boolean;
    onClose: VoidFunction;
    onSave: VoidFunction;
};

export function ToggleDialog({
    activeToggle,
    isOpen,
    templateKey,
    originFromEdition,
    onClose,
    onSave,
}: ToggleDialogProps): JSX.Element {
    const { t } = useTranslation();

    return (
        <Dialog isOpen={isOpen}>
            <DialogHeader
                showClose
                onClose={onClose}
                title={t(`branded-emails.toggle-dialog.${activeToggle ? 'title' : 'activate-title'}`)}
            />

            <DialogContent>
                <Typography variant="body1">
                    {activeToggle
                        ? t('branded-emails.toggle-dialog.content')
                        : t('branded-emails.toggle-dialog.activate-content', {
                              emailTemplate: templateKey,
                          })}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button size={ButtonSize.SMALL} variant={ButtonVariant.OUTLINED} onClick={onClose}>
                    {t(
                        `branded-emails.toggle-dialog.${originFromEdition ? 'continue-editing' : activeToggle ? 'reject' : 'cancel'}`,
                    )}
                </Button>
                <Button size={ButtonSize.SMALL} onClick={onSave}>
                    {t(`branded-emails.toggle-dialog.${activeToggle ? 'accept' : 'activate'}`)}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
